module.exports = __webpack_public_path__ + "img/logo.ca0954f9.svg";